import _CheckmarkIcon from "@adsk/alloy-react-icon/es/lib/CheckmarkIcon";
import _styled2 from "styled-components";
import _styled from "styled-components";
const _excluded = ["isSelected", "isMultiple", "isHighlighted", "disabled", "text", "subtext", "renderLeftComponent", "renderRightComponent", "onClick", "style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styledC from 'styled-components';
import Checkbox from '@adsk/alloy-react-checkbox';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
const Label = styledC.div.withConfig({
  displayName: "MenuItem__Label",
  componentId: "sc-w7bdbb-0"
})(["", " ", " color:", ";width:100%;"], theme.typography.ellipsis, props => props.$isSelected && !props.$disabled ? theme.typography.bodyMediumBold : theme.typography.bodyMedium, props => props.$disabled ? theme.tokens.colors.text.inactive.value : 'inherit');
const Subtext = styledC.div.withConfig({
  displayName: "MenuItem__Subtext",
  componentId: "sc-w7bdbb-1"
})(["", " ", " color:", ";"], theme.typography.ellipsis, theme.typography.bodyMedium, props => props.disabled ? theme.tokens.colors.text.inactive.value : theme.tokens.colors.text.secondary.value);
const StyledLi = styledC.li.withConfig({
  displayName: "MenuItem__StyledLi",
  componentId: "sc-w7bdbb-2"
})(["display:flex;align-items:flex-start;box-sizing:border-box;padding:", "px ", "px;cursor:", ";background-color:", ";&:active{background-color:", ";}"], theme.spacing.XS, theme.spacing.M, props => props.disabled ? undefined : 'pointer', props => props.$isSelected && !props.$isMultiple ? theme.tokens.colors.background.selected.subtler.value : props.$isHighlighted && !props.disabled ? theme.tokens.colors.background.neutral.hover.value : undefined, props => props.disabled ? undefined : theme.tokens.colors.background.neutral.pressed.value);
var _StyledStyledLi = styledC(StyledLi).withConfig({
  displayName: "MenuItem___StyledStyledLi",
  componentId: "sc-w7bdbb-3"
})(["", ""], p => p.$_css);
const MenuItem = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      isSelected,
      isMultiple,
      isHighlighted,
      disabled,
      text: label,
      subtext,
      renderLeftComponent,
      renderRightComponent,
      onClick: rawOnClick,
      style
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const onClick = useCallback(args => {
    if (!disabled) {
      rawOnClick === null || rawOnClick === void 0 ? void 0 : rawOnClick(args);
    }
  }, [disabled, rawOnClick]);
  return /*#__PURE__*/React.createElement(_StyledStyledLi, _extends({
    ref: ref,
    disabled: disabled,
    $isSelected: isSelected,
    $isMultiple: isMultiple,
    $isHighlighted: isHighlighted,
    onClick: onClick
  }, props, {
    $_css: style
  }), isMultiple && /*#__PURE__*/React.createElement(Checkbox, {
    checked: isSelected,
    style: {
      marginRight: theme.spacing.XS,
      marginTop: subtext ? theme.spacing.XXXS : theme.spacing.XXS
    },
    disabled: disabled,
    readOnly: true
  }), renderLeftComponent && renderLeftComponent(), /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css2: !subtext && {
      display: 'flex',
      alignItems: 'center',
      minHeight: 24
    }
  }, label && /*#__PURE__*/React.createElement(Label, {
    $disabled: disabled,
    $isSelected: isSelected
  }, label), subtext && /*#__PURE__*/React.createElement(Subtext, {
    disabled: disabled
  }, subtext)), renderRightComponent ? renderRightComponent() : !disabled && isSelected && !isMultiple && /*#__PURE__*/React.createElement(_CheckmarkIcon, {
    style: {
      color: theme.tokens.colors.icon.selected.value,
      padding: "-".concat(theme.spacing.XXXS, "px, 0px")
    }
  }));
});
MenuItem.displayName = 'MenuOption';
MenuItem.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Whether menu option is currently selected */
  isSelected: PropTypes.bool,
  /** Whether menu option is currently highlighted.  Used when cursor navigation */
  isHighlighted: PropTypes.bool,
  /** Whether menu option is in a multi select */
  isMultiple: PropTypes.bool,
  /** Whether menu option is disabled */
  disabled: PropTypes.bool,
  /** Primary content */
  text: PropTypes.any,
  /** Secondary content */
  subtext: PropTypes.any,
  /** component to render to the left of the item */
  renderLeftComponent: PropTypes.func,
  /** component to render to the right of the item */
  renderRightComponent: PropTypes.func,
  /** Function executed on click */
  onClick: PropTypes.func
};
export default MenuItem;
var _StyledDiv = styledC("div").withConfig({
  displayName: "MenuItem___StyledDiv",
  componentId: "sc-w7bdbb-4"
})(p => _objectSpread({
  flex: 1,
  overflow: 'hidden'
}, p.$_css2));
//# sourceMappingURL=MenuItem.js.map